import Login from "./login";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { generateOtp } from "services/redux/auth/loginOtp/action";

const mapStateToProps = (state) => ({
  otp: state.loginOtp.otp,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      generateOtp,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Login);
